export const getLocalStorageSafe = (key: string) => {
    let value: string | null = '';
    try {
        value = localStorage.getItem(key);
    } catch (_e) {
        console.error('localStorage.getItem is not available');
    }
    return value;
};

export const setLocalStorageSafe = (key: string, value: unknown) => {
    try {
        localStorage.setItem(key, String(value));
    } catch (_e) {
        console.error('localStorage.setItem is not available');
    }
};
